import React from 'react'

import { Item, Box } from 'react-html-email';


import Row from "./row";

const IfElse = ({ content, section, parentIndex, html }) => {
    return (
        <React.Fragment>
            <span dangerouslySetInnerHTML={{
                __html: `<!--[#if ${content.config.condition}]-->`
            }}></span>
            <Box>
                {content.config.if.content.map((ifContent, index) => (
                    <Item key={index} align={content.align}>
                        <Row
                            content={ifContent}
                            section={`${section}_${parentIndex}_if`}
                            index={index}
                            html={html}
                        />
                    </Item>
                ))}
            </Box>
            <span dangerouslySetInnerHTML={{
                __html: `<!--[#else]-->`
            }}></span>
            <Box>
                {content.config.else.content.map((elseContent, index) => (
                    <Item key={index} align={content.align}>
                        <Row
                            content={elseContent}
                            section={`${section}_${parentIndex}_else`}
                            index={index}
                            html={html}
                        />
                    </Item>
                ))}
            </Box>
            <span dangerouslySetInnerHTML={{
                __html: `<!--[/#if]-->`
            }}></span>
        </React.Fragment>
    );
};

export default IfElse;
